<template>
  <div class="customize_homework">
    <div class="homework_name">{{ homeworkInfo.homeworkName }}</div>
    <div class="homework_difficult flex Flexalign mt-20">
      <div class="line_green"></div>
      <div class="difficult_text ml-8">作业描述</div>
    </div>
    <div class="homework_desc mt-15">{{ homeworkInfo.homeworkDescription }}</div>
    <div class="homework_difficult flex Flexalign mt-20">
      <div class="line_green"></div>
      <div class="difficult_text ml-8">作业内容</div>
    </div>
    <div class="homework_desc mt-15" v-html="homeworkInfo.customHomeworkContent"></div>
    <div class="homework_difficult flex Flexalign mt-20" v-if="homeworkInfo.customHomeworkFile?.length">
      <div class="line_green"></div>
      <div class="difficult_text ml-8">作业附件</div>
    </div>
    <div class="homework_desc mt-15" v-if="homeworkInfo.customHomeworkFile?.length">
      <div class="cursor_pointer file_name" v-for="(item, index) in homeworkInfo.customHomeworkFile" :key="index"
        @click="openFile(item.url)">
        {{ item.name }}
      </div>
    </div>
    <div v-if="!isAnswerSheet">
      <div class="dash_line mt-20"></div>
      <div class="homework_difficult flex Flexalign mt-20">
        <div class="line_green"></div>
        <div class="difficult_text ml-8">作业提交</div>
      </div>
      <div class="mt-15">
        <quillEditor :model-value="doAnswer" @update:model-value="getAnswer"></quillEditor>
      </div>
      <div class="annex_lable flex mt-20 Flexalign">
        <span class="red_star">*</span>
        <div class="ml-5">附件上传</div>
        <div class="annex_label_text ml-10">可上传多个附件</div>
      </div>
      <div class="mt-15 upload_box">
        <el-upload class="upload-demo" v-model:file-list="fileList" drag :action="uploadUrl" multiple
          :on-preview="handlePreview" list-type="picture" :on-progress="handleUploadProgress"
          :on-success="handleUploadSuccess" :on-error="handleUploadError" :on-change="handleFileChange">
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
          <div class="el-upload__text"><em>点击上传附件</em></div>
          <!-- 自定义文件列表项 -->
          <template #file="{ file }">
            <div class="custom-file-item">
              <!-- 统一缩略图图标 -->
              <div class="file-thumbnail">
                <el-image v-if="isImage(file)" class="img_box" :src="file.response?.data?.url"></el-image>
                <el-icon v-else>
                  <Document />
                </el-icon>
              </div>

              <!-- 文件名 -->
              <span class="file-name">{{ file.name }}</span>

              <!-- 状态图标（成功显示√，悬停显示×） -->
              <div class="file-actions">
                <el-icon v-if="file.status === 'success'" class="success-icon">
                  <CircleCheck />
                </el-icon>
                <el-icon v-if="file.status === 'success'" class="delete-icon" @click.stop="handleRemove(file)">
                  <CircleClose />
                </el-icon>
              </div>
            </div>
          </template>
        </el-upload>
      </div>
      <div class="btn_submit mt-40 cursor_pointer" @click="submit">提交作业</div>
    </div>
    <div v-else>
      <customAnswerSheet :type="2" :id="examInfo.homeworkId" :examInfo="examInfo" :homeworkInfo="homeworkInfo"
        @goBack="goBack">
      </customAnswerSheet>
    </div>
  </div>
</template>

<script>
import quillEditor from "@/components/quillEditor/index.vue";
import { mapState } from "vuex";
import * as config from "@/config/config";
import customAnswerSheet from "./components/customAnswerSheet.vue";
export default {
  name: "GjkcH5CustomizeHomework",
  components: { quillEditor, customAnswerSheet },
  computed: {
    ...mapState({
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
    }),
  },
  props: {
    examInfo: {},
    homeworkType: {},
  },

  watch: {
    examInfo: {
      handler() {
        this.getCustomizeHomeworkInfo();
      },
      deep: true,
      immediate: true,
    },
  },

  data() {
    return {
      homeworkInfo: {
        name: "",
        desc: "",
        content: "",
      },
      uploadUrl: "",
      fileList: [],
      doAnswer: "",
      isUploading: false, // 全局上传状态
      uploadProgress: 0, // 总进度百分比
      activeUploads: new Set(), // 记录正在上传的文件ID
      loading: {}, // loading
      isAnswerSheet: false,
    };
  },

  mounted() {
    this.uploadUrl = config.COMMON_UPLOAD_URL;
    this.getCustomAnswerSheet();
  },

  methods: {
    goBack() {
      this.$emit("goBack");
    },
    // 用于判断是否有答题卡
    getCustomAnswerSheet() {
      this.$Api.course
        .getCustomAnswerSheet(2, this.examInfo.homeworkId)
        .then((res) => {
          if (!this.$Tools.empty(res.data.data.answerCard)) {
            this.isAnswerSheet = true;
            // 单独添加答题卡。目前接口未返回
            this.homeworkInfo.answerCard = res.data.data.answerCard;
          } else {
            this.isAnswerSheet = false;
          }
        })
        .catch(() => { });
    },
    // 文件加入队列时触发
    handleFileChange(file) {
      if (file.status === "ready") {
        this.activeUploads.add(file.uid);
        this.isUploading = true;
        this.loading = this.$Dialog.loading("文件上传中...");
      }
    },

    // 上传进度更新（支持多文件）
    handleUploadProgress(event, file) {
      const totalSize = this.fileList.reduce((sum, f) => sum + f.size, 0);
      const loadedSize = this.fileList.reduce((sum, f) => {
        return sum + (f.uid === file.uid ? event.loaded : f.size);
      }, 0);
      this.uploadProgress = Math.round((loadedSize / totalSize) * 100);
    },

    // 单个文件上传成功
    handleUploadSuccess(response, file) {
      // 此处要判断是否是上传成功，超出文件大小限制的要去掉
      if (this.$Tools.empty(response.data)) {
        this.$message.error(`${response.message}`);
        // 删除上传失败的原生
        this.fileList.pop();
      }
      this.activeUploads.delete(file.uid);
      this.checkAllUploaded();
    },

    // 单个文件上传失败
    handleUploadError(err, file) {
      this.activeUploads.delete(file.uid);
      this.checkAllUploaded();
      this.$message.error(`${file.name} 上传失败，请重试`);
    },

    // 检查所有文件是否完成
    checkAllUploaded() {
      if (this.activeUploads.size === 0) {
        this.isUploading = false;
        this.uploadProgress = 0;
        // if(!this.$Tools.empty(this.loading)){
        // }
      }
      // 清除loading
      this.loading.close();
      this.loading = {};
    },
    // 文件删除处理
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      if (index !== -1) {
        this.fileList.splice(index, 1);
      }
    },

    // 上传成功处理
    handleSuccess(response, file) {
      file.status = "success";
    },
    isImage(file) {
      return (
        file.raw?.type?.startsWith("image/") ||
        /\.(jpg|jpeg|png|gif|webp)$/i.test(file.name)
      );
    },
    // 富文本获取内容
    getAnswer(info) {
      this.doAnswer = info;
    },
    getFileName(url) {
      return url.split("/").pop();
    },
    openFile(url) {
      window.open(url);
    },
    handlePreview(file) {
      console.log(file);
    },
    getCustomizeHomeworkInfo() {
      // 课后作业
      if (this.homeworkType == "afterHomework") {
        if (this.examInfo.recordId) {
          this.$Api.exam
            .getAfterHomeworkCustomRecord(this.examInfo.recordId)
            .then((res) => {
              this.homeworkInfo = res.data.data;
              this.doAnswer = res.data.data.assignmentContentAnswer;
              this.fileList = [];
              // 模拟上传后的数组格式
              res.data.data.assignmentFileAnswer.forEach((item) => {
                this.fileList.push({
                  name: item.name,
                  response: {
                    data: {
                      url: item.url,
                    },
                  },
                  size: item.size,
                  raw: {
                    mimeType: {
                      type: item.mimeType,
                    },
                  },
                });
              });
            })
            .catch(() => { });
          return;
        }
        this.$Api.exam
          .getAfterHomeworkCustom(this.examInfo.homeworkId)
          .then((res) => {
            this.homeworkInfo = res.data.data;
          })
          .catch(() => { });
      } else {
        if (this.examInfo.recordId) {
          this.$Api.exam
            .getCustomizeHomeworkRecordInfo(this.examInfo.recordId)
            .then((res) => {
              this.homeworkInfo = res.data.data;
              this.doAnswer = res.data.data.assignmentContentAnswer;
              this.fileList = [];
              // 模拟上传后的数组格式
              res.data.data.assignmentFileAnswer.forEach((item) => {
                this.fileList.push({
                  name: item.name,
                  response: {
                    data: {
                      url: item.url,
                    },
                  },
                  size: item.size,
                  raw: {
                    mimeType: {
                      type: item.mimeType,
                    },
                  },
                });
              });
            })
            .catch(() => { });
          return;
        }
        this.$Api.exam
          .getCustomizeHomeworkInfo(this.examInfo.examId)
          .then((res) => {
            this.homeworkInfo = res.data.data;
          })
          .catch(() => { });
      }
    },
    submit() {
      let fileList = [];
      this.fileList.forEach((item) => {
        fileList.push({
          name: item.name,
          url: item.response?.data?.url,
          size: item.size,
          mimeType: item.raw?.type,
        });
      });
      let listQuery = {};
      if (this.homeworkType != "afterHomework") {
        listQuery = {
          examId: this.examInfo.examId,
          examName: this.homeworkInfo.examName,
          examDetail: this.homeworkInfo.examDetail,
          assignmentContent: this.homeworkInfo.assignmentContent,
          assignmentFile: this.homeworkInfo.assignmentFile,
          assignmentContentAnswer: "",
          assignmentFileAnswer: [],
          answerCard: this.answerSheetList?.answerCard || [],
        };
      } else {
        listQuery = {
          homeworkId: this.homeworkInfo.homeworkId,
          homeworkName: this.homeworkInfo.homeworkName,
          homeworkDescription: this.homeworkInfo.homeworkDescription,
          customHomeworkContent: this.homeworkInfo.assignmentContent,
          customHomeworkFile: this.homeworkInfo.assignmentFile,
          customHomeworkContentAnswer: "",
          customHomeworkFileAnswer: [],
          answerCard: this.answerSheetList?.answerCard || [],
        };
      }
      if (this.homeworkType != "afterHomework") {
        listQuery.assignmentContentAnswer = this.doAnswer;
        listQuery.assignmentFileAnswer = fileList;
      }else{
        listQuery.customHomeworkContentAnswer = this.doAnswer;
        listQuery.customHomeworkFileAnswer = fileList;
      }
      this.$Dialog.confirm({
        message: "作业提交前请细查细节，是否确认无误提交作业",
        title: "提示", // 可选，不传则使用默认值'确认'
        onConfirm: () => {
          if (this.homeworkType != "afterHomework") {
            this.$Api.exam
              .submitCustomizeHomework(listQuery)
              .then(() => {
                this.$Dialog.toast("提交成功,请等待老师的批阅");
                setTimeout(() => {
                  // this.$emit("goBack");
                  // 此处加入判断，判断提交后当前输入（作业）一步是否已完成，已完成则可以选择点击进入下一步
                  this.$Api.course
                    .getMyCourseChapterProgress({
                      schemeChapterPhaseId: this.selectLearningInfo?.id,
                    })
                    .then((res) => {
                      if (res.data.data.outputStatus == 1) {
                        this.$Dialog.confirm({
                          message: "当前作业已全部完成，是否前往下一步",
                          title: "提示", // 可选，不传则使用默认值'确认'
                          onConfirm: () => {
                            this.$store.commit("learning/setStudyStepInfo", 2);
                          },
                          onCancel: () => {
                            this.$emit("goBack");
                          },
                        });
                      } else {
                        this.$emit("goBack");
                      }
                    })
                    .catch(() => {});
                }, 500);
              })
              .catch(() => {});
          } else {
            this.$Api.exam
              .submitAfterCustomizeHomework(listQuery)
              .then(() => {
                this.$Dialog.toast("提交成功,请等待老师的批阅");
                setTimeout(() => {
                  this.$emit("goBack");
                  // 此处加入判断，判断提交后当前输入（作业）一步是否已完成，已完成则可以选择点击进入下一步
                }, 500);
              })
              .catch(() => {});
          }
        }, // 确认后的操作，如调用删除API等
        onCancel: () => {}, // 取消后的操作，可选不传则无动作。也可以在这里添加其他逻辑。
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.customize_homework {
  .homework_name {
    width: 100%;
    text-align: center;
    font-size: 18px;
    color: #111111;
  }

  .homework_difficult {
    font-size: 12px;
    color: #999999;

    .line_green {
      width: 3px;
      height: 16px;
      background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
      border-radius: 4px;
    }

    .difficult_text {
      font-size: 14px;
      color: #111111;
    }
  }

  .homework_desc {
    font-size: 14px;
    color: #666660;
    line-height: 24px;

    .file_name {
      color: rgb(49, 49, 237);
      text-decoration: underline;
    }
  }

  .dash_line {
    border: 1px dashed rgba(0, 0, 0, 0.1);
  }

  .annex_lable {
    font-size: 14px;

    .red_star {
      color: #f81616;
    }

    .annex_label_text {
      font-size: 12px;
      color: #999999;
    }
  }

  .btn_submit {
    margin: 40px auto;
    width: 160px;
    height: 48px;
    background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
    border-radius: 30px;
    text-align: center;
    line-height: 48px;
    color: #ffffff;
  }
}

.custom-file-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px;
  // border: 1px solid #e4e7ed;
  width: 100%;
  margin-bottom: 5px;
  border-radius: 4px;
}

.file-thumbnail {
  margin-right: 10px;
  font-size: 24px;
  color: #409eff;
}

.file-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-actions {
  position: absolute;
  top: -8px;
  right: -8px;
}

.success-icon {
  color: #67c23a;
  font-size: 16px;
  background: white;
  border-radius: 50%;
}

.delete-icon {
  display: none;
  color: #f56c6c;
  font-size: 16px;
  background: white;
  border-radius: 50%;
  cursor: pointer;
}

.custom-file-item:hover .delete-icon {
  display: block;
}

.custom-file-item:hover .success-icon {
  display: none;
}

.img_box {
  width: 60px;
  height: 60px;
  border-radius: 10px;
}
</style>
